<template>
  <DxPopup @hidden="onHidden" :visible="showEpms7020" :show-close-button="true" :show-title="true" :title="''" width="1024" min-height="800" max-height="800" :container="container" :resizeEnabled="true">
    <!-- <v-container fluid align-start ma-0 pa-2 class="epms7020-main container-height"> -->
      <v-row no-gutters class="epms7020-main">
        <v-col cols="12">
          <i-card-vertical
            :headerTitle="'Pipe Detail Quotation List By Por. No'"
            :useBtnList="['btnPrint']"
            @btnPrint="btnPrint">
            <template v-slot:body>
              <v-row no-gutters class="center pa-2 pb-0">
                <i-label :label="'Quot No : '"/>
                <v-col cols="2">
                  <v-text-field 
                    v-model="param.quotNo" 
                    dense 
                    outlined 
                    hide-details="auto"
                    readonly />
                </v-col>

                <i-label :label="'Ship No : '" class="pl-2"/>
                <v-col cols="1">
                  <v-text-field 
                    v-model="param.shipNo" 
                    dense 
                    outlined 
                    hide-details="auto"
                    readonly />
                </v-col>

                <i-label :label="'POR No : '" class="pl-2"/>
                <v-col cols="1">
                  <v-text-field 
                    v-model="param.porNo" 
                    dense 
                    outlined 
                    hide-details="auto"
                    readonly />
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12" class="pa-0">
                  <DxDataGrid
                    class="pt-1"
                    :ref="epms7020Ref"
                    height="625"
                    :data-source="dataList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    :column-min-width="100"
                  >
                    <DxColumn data-field="porSeq" header-cell-template="porSeqHdrTmpl" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                    <template #porSeqHdrTmpl>
                      <div>POR<br>Seq</div>
                    </template>
                    <DxColumn data-field="instBlock" header-cell-template="instBlockHdrTmpl" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                    <template #instBlockHdrTmpl>
                      <div>Inst<br>Block</div>
                    </template>
                    <DxColumn data-field="pieceNo" caption="Piece No" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                    <DxColumn data-field="dias" caption="Dias" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                    <DxColumn caption="Welding Price" data-type="string" alignment="center" :visible="true" :allow-editing="false">
                      <DxColumn data-field="tigAmt" caption="Tig" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                      <DxColumn data-field="arcAmt" caption="Arc" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                      <DxColumn data-field="bendAmt" caption="Bend'g" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption="Material Price" data-type="string" alignment="center" :visible="true" :allow-editing="false">
                      <DxColumn data-field="pipeAmt" caption="Pipe" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                      <DxColumn data-field="pipeLossAmt" header-cell-template="pipeLossPriceHdrTmpl" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                      <DxColumn data-field="flangeAmt" caption="Flange" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                      <DxColumn data-field="elbowAmt" caption="Elbow" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                      <DxColumn data-field="sleeveAmt" caption="Sleeve" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                      <DxColumn data-field="reducerAmt" caption="Reducer" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                      <DxColumn data-field="etcMatlAmt" caption="Etc" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                    </DxColumn>
                    <template #pipeLossPriceHdrTmpl>
                      <div>Pipe<br>Loss</div>
                    </template>
                    <DxColumn caption="Proc. Price" data-type="string" alignment="center" :visible="true" :allow-editing="false">
                      <DxColumn data-field="aprocCd" header-cell-template="aprocCodePriceHdrTmpl" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                      <DxColumn data-field="wgt" caption="Weight" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                      <DxColumn data-field="acidAmt" caption="Acid" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                      <DxColumn data-field="galvAmt" caption="Galv" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                      <DxColumn data-field="pntAmt" caption="Paint" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                      <DxColumn data-field="maskingAmt" caption="Masking" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                    </DxColumn>
                    <template #aprocCodePriceHdrTmpl>
                      <div>Aproc<br>Code</div>
                    </template>
                    <DxColumn caption="Insp. Price" data-type="string" alignment="center" :visible="true" :allow-editing="false">
                      <DxColumn data-field="inspRtAmt" caption="R.T" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                      <DxColumn data-field="inspPtAmt" caption="P.T" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                      <DxColumn data-field="inspHtAmt" caption="H.T" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn data-field="clsAmt" header-cell-template="clsssPriceHdrTmpl" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                    <template #clsssPriceHdrTmpl>
                      <div>Clsss<br>Price</div>
                    </template>
                    <DxColumn data-field="etcAmt" header-cell-template="etcPriceHdrTmpl" caption="Etc Price" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                    <template #etcPriceHdrTmpl>
                      <div>ETC<br>Price</div>
                    </template>
                    <DxColumn data-field="rmk" caption="Remark" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                  </DxDataGrid>
                </v-col>
              </v-row>
            </template>
          </i-card-vertical>
        </v-col>
      </v-row>
    <!-- </v-container> -->
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup'
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardVertical.vue'
import { getEpms7020 } from '@/api/view/hip/1/epms1020'
import { reportView } from '@/api/view/hip/common/common'

export default {
  name: 'epms7020',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxPopup,
    iCardTop,
    iCardVertical
  },
  props: {
    container: {
      type: String,
      default() {
        return '.v-application'
        // return '.epms1020-main'
      }
    },
    showEpms7020: {
      type: Boolean,
      default() {
        return false
      }
    },
    param: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      epms7020Ref: 'epms7020Ref',
      dataList: []
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epms7020Ref)
    }
  },
  watch: {
    'showEpms7020': {
      handler(value, oldValue) {
        if(value) {
          this.init()
          this.getData()
        }
      },
      immediate: true
    }
  },
  methods: {
    init() {
      this.dataList = []
    },
    getData() {
      getEpms7020(this.param).then(res => {
        // console.log('getEpms7020Res', res)

        let data = res.list

        for(let i = 0; i < data.length; i++) {
          data[i].id = i + 1
        }

        this.dataList = data
      })
    },
    btnPrint() {
      this.vToastifyPrompt(
        this.$t('Are You Print?'),
        'info',
        current => {
          const param = {
            fileName: 'por_sheet.jrxml',
            as_quot_no: this.param.quotNo,
          }

          reportView(param)
          .catch(error => {
            this.vToastify(error, 'warn')
          }).finally(() => {
            this.endLoading()
          })
        },
        null,
        true
      )
    },
    onHidden(e) {
      this.$emit('update:showEpms7020', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.epms7020-main {
  .subTitle {
    font-weight: bold;
    color: black;
  }
}
</style>